export default {
  redeemCode: {
    title: 'Đổi Mã',
    description: 'Nhập mã đổi thưởng của bạn bên dưới để nhận phần thưởng.',
    enterTip: 'Nhập mã đổi thưởng của bạn để nhận phần thưởng',
    label: 'Mã Đổi Thưởng',
    placeholder: 'Nhập mã đổi thưởng',
    submit: 'Đổi',
    redeemBtn: 'ĐỔI THƯỞNG',
    submitting: 'Đang đổi...',
    success: 'Đổi mã thành công!',
    redeemSuccess: 'Đổi mã thành công!',
    failed: 'Đổi mã thất bại, vui lòng thử lại.',
    redeemFailed: 'Đổi mã thất bại, vui lòng thử lại.'
  }
};
